export default __webpack_public_path__ + "static/media/img (3).b8bedabc.jpg";